{
  "v9.exceptions.action.platform.billing_exception_cancelled": "Exception cancelled",
  "v9.exceptions.action.platform.billing_exception_countersign_refused": "Second signature refused",
  "v9.exceptions.action.platform.billing_exception_countersigned": "Countersigned",
  "v9.exceptions.action.platform.billing_exception_granted": "Exception granted",
  "v9.exceptions.aide.confirmation": "Your password confirms your identity; it is not stored.",
  "v9.exceptions.aide.date_effet": "By default, the next due date.",
  "v9.exceptions.aide.motif": "At least {{n}} characters.",
  "v9.exceptions.aide.operations_en_cours": "Operations in progress stay in the original currency.",
  "v9.exceptions.aide.pieces": "PDF, PNG or JPEG, 5 MB max per file.",
  "v9.exceptions.annuler": "Cancel",
  "v9.exceptions.annuler_exception": "Cancel the exception",
  "v9.exceptions.champ.complement": "Additional information",
  "v9.exceptions.champ.confirmation": "Password (re-authentication)",
  "v9.exceptions.champ.date_effet": "Requested effective date",
  "v9.exceptions.champ.devise": "Currency",
  "v9.exceptions.champ.devise_cible": "Target currency",
  "v9.exceptions.champ.duree": "Duration (days)",
  "v9.exceptions.champ.facture": "Invoice concerned (identifier)",
  "v9.exceptions.champ.mode": "Payment method",
  "v9.exceptions.champ.montant": "Amount",
  "v9.exceptions.champ.motif": "Reason",
  "v9.exceptions.champ.motif_annulation": "Cancellation reason",
  "v9.exceptions.champ.motif_seconde": "Reason (optional)",
  "v9.exceptions.champ.nature": "Request type",
  "v9.exceptions.champ.palier": "Tier",
  "v9.exceptions.champ.periodicite": "Billing period",
  "v9.exceptions.champ.pieces": "Attachments",
  "v9.exceptions.champ.prix": "Price",
  "v9.exceptions.champ.validite": "Valid until",
  "v9.exceptions.code.CONFIRMATION_IDENTITE_ECHOUEE": "Identity confirmation failed.",
  "v9.exceptions.code.CONFIRMATION_IDENTITE_REQUISE": "Confirm your identity before this action.",
  "v9.exceptions.code.CONTEXTE_INCOMPLET": "No organisation in the session.",
  "v9.exceptions.code.CONTRESIGNATURE_NON_REQUISE": "No second signature is expected for this exception.",
  "v9.exceptions.code.DELAI_DE_REFLEXION_EN_COURS": "Self-approval: the cooling-off period is still running.",
  "v9.exceptions.code.DEMANDE_CLOSE": "This request is closed.",
  "v9.exceptions.code.DEMANDE_DEJA_ACCORDEE": "This request is granted: it can no longer be withdrawn.",
  "v9.exceptions.code.DEMANDE_IDENTIQUE_DEJA_OUVERTE": "A request of the same kind, for the same invoice, is already open.",
  "v9.exceptions.code.DEVIS_EXPIRE": "This quote has expired.",
  "v9.exceptions.code.DEVIS_REMPLACE": "This quote revision has been replaced by a newer one.",
  "v9.exceptions.code.DROIT_NON_TENU": "You don't hold the required right.",
  "v9.exceptions.code.EXCEPTION_DEJA_EXECUTEE": "This exception is executed, even partially: settle it instead of cancelling it.",
  "v9.exceptions.code.IDEMPOTENCY_CONFLICT": "This request was already sent with different content.",
  "v9.exceptions.code.MOYEN_DE_PAIEMENT_REQUIS": "This quote requires a debit: add a payment method first.",
  "v9.exceptions.code.PAIEMENT_REFUSE": "The payment was refused by the provider.",
  "v9.exceptions.code.PALIER_SUR_MESURE_COLLISION": "The custom tier cannot be created: contact the platform.",
  "v9.exceptions.code.PRESTATAIRE_INDISPONIBLE": "The payment provider is unreachable: try again later.",
  "v9.exceptions.code.PROPRIETAIRE_SEUL": "Reserved for the organisation owner.",
  "v9.exceptions.code.RESOURCE_UNAVAILABLE": "Item not found.",
  "v9.exceptions.code.SANS_SESSION": "Session expired: sign in again.",
  "v9.exceptions.code.VALIDATION_ERROR": "Invalid input: check the reason, currency, date and attachments.",
  "v9.exceptions.code.VALIDATION_PAR_UN_TIERS": "The requester cannot countersign: another platform administrator validates.",
  "v9.exceptions.code.VERSION_CONFLICT": "Changed in the meantime: reload the page before trying again.",
  "v9.exceptions.complement.ajoute": "Information added to the history.",
  "v9.exceptions.complement.ajouter": "Add the information",
  "v9.exceptions.demandeur": "Requested by {{qui}}",
  "v9.exceptions.devis.accepte": "Quote accepted: the subscription is recorded (change {{changement}}).",
  "v9.exceptions.devis.accepter": "Accept the quote",
  "v9.exceptions.devis.decliner": "Decline the quote",
  "v9.exceptions.devis.proposition": "Revision {{n}}: {{montant}}, {{periodicite}}",
  "v9.exceptions.devis.quotas": "Quote quotas",
  "v9.exceptions.devis.revision_n": "Revision {{n}}",
  "v9.exceptions.devis.validite": "Valid until {{date}}",
  "v9.exceptions.devis.vide": "No proposal yet.",
  "v9.exceptions.ecran.dialogue-demander-exception-facturation": "Request a billing exception from the platform",
  "v9.exceptions.ecran.dialogue-exception-facturation": "Grant a billing exception",
  "v9.exceptions.ecran.organisation-demande-exception-fiche": "Billing exception request follow-up",
  "v9.exceptions.ecran.plateforme-exception-facturation-fiche": "Billing exception follow-up",
  "v9.exceptions.en_cours": "In progress…",
  "v9.exceptions.envoyee": "Request sent to the platform.",
  "v9.exceptions.envoyer": "Send the request",
  "v9.exceptions.erreur.accepter": "The quote could not be accepted.",
  "v9.exceptions.erreur.accorder": "The exception could not be recorded.",
  "v9.exceptions.erreur.annuler": "The exception could not be cancelled.",
  "v9.exceptions.erreur.completer": "The information could not be added.",
  "v9.exceptions.erreur.contresigner": "The second signature could not be recorded.",
  "v9.exceptions.erreur.decliner": "The quote could not be declined.",
  "v9.exceptions.erreur.envoyer": "The request could not be sent.",
  "v9.exceptions.erreur.refuser": "The refusal could not be recorded.",
  "v9.exceptions.erreur.retirer": "The request could not be withdrawn.",
  "v9.exceptions.etat.accordee": "Granted",
  "v9.exceptions.etat.chargement": "Loading {{quoi}}…",
  "v9.exceptions.etat.devis_accepte": "Quote accepted",
  "v9.exceptions.etat.devis_decline": "Quote declined",
  "v9.exceptions.etat.devis_expire": "Quote expired",
  "v9.exceptions.etat.devis_propose": "Quote proposed",
  "v9.exceptions.etat.en_instruction": "Under review",
  "v9.exceptions.etat.envoyee": "Sent",
  "v9.exceptions.etat.erreur": "Unable to load {{quoi}}.",
  "v9.exceptions.etat.refus": "You don't have access to this information.",
  "v9.exceptions.etat.refusee": "Refused",
  "v9.exceptions.etat.retiree": "Withdrawn",
  "v9.exceptions.etat.vide": "Nothing to show.",
  "v9.exceptions.etat_exception.annulee": "Cancelled",
  "v9.exceptions.etat_exception.demandee": "Requested",
  "v9.exceptions.etat_exception.echouee": "Failed at the payment provider",
  "v9.exceptions.etat_exception.en_attente_de_seconde_signature": "Awaiting second signature",
  "v9.exceptions.etat_exception.en_attente_du_prestataire": "Awaiting the payment provider",
  "v9.exceptions.etat_exception.executee": "Executed",
  "v9.exceptions.etat_exception.partiellement_executee": "Partially executed",
  "v9.exceptions.etat_exception.refusee_par_le_second_signataire": "Refused by the second signatory",
  "v9.exceptions.etat_exception.regularisee": "Settled",
  "v9.exceptions.etat_revision.acceptee": "accepted",
  "v9.exceptions.etat_revision.declinee": "declined",
  "v9.exceptions.etat_revision.en_vigueur": "current",
  "v9.exceptions.etat_revision.expiree": "expired",
  "v9.exceptions.etat_revision.remplacee": "replaced by a revision",
  "v9.exceptions.evenement.complement": "Additional information",
  "v9.exceptions.evenement.piece": "Attachment",
  "v9.exceptions.evenement.reponse": "Platform response",
  "v9.exceptions.evenement.retrait": "Request withdrawn",
  "v9.exceptions.exception.creee": "Exception recorded.",
  "v9.exceptions.facture_n": "invoice {{facture}}",
  "v9.exceptions.historique.vide": "No events.",
  "v9.exceptions.invalide.complement": "The information is empty.",
  "v9.exceptions.invalide.date": "The effective date is in the past.",
  "v9.exceptions.invalide.devis": "The quote needs a price, a validity date and whole-number quotas.",
  "v9.exceptions.invalide.devise": "Choose a currency different from the current one.",
  "v9.exceptions.invalide.duree": "The duration is a positive number of days.",
  "v9.exceptions.invalide.essai": "The trial needs a tier and a positive duration.",
  "v9.exceptions.invalide.format": "Unsupported file format (PDF, PNG, JPEG).",
  "v9.exceptions.invalide.montant": "Invalid amount: two decimals at most.",
  "v9.exceptions.invalide.motif": "The reason must be at least 15 characters long.",
  "v9.exceptions.invalide.motif_annulation": "The cancellation reason is required.",
  "v9.exceptions.invalide.palier": "Choose the requested tier.",
  "v9.exceptions.invalide.volumineuse": "File too large: 5 MB max.",
  "v9.exceptions.mode.debit": "Debit by the payment provider",
  "v9.exceptions.mode.virement": "Bank transfer on invoice",
  "v9.exceptions.montant_souhaite": "Requested amount: {{montant}}",
  "v9.exceptions.moyen.ajouter": "Add a payment method",
  "v9.exceptions.moyen.facultatif": "Payment on invoice by bank transfer: no payment method required.",
  "v9.exceptions.moyen.obligatoire": "This quote requires a debit: a payment method is required.",
  "v9.exceptions.moyen.utilise": "Payment method used for the subscription: {{moyen}}",
  "v9.exceptions.nature.avoir": "Credit note",
  "v9.exceptions.nature.changement_de_devise_pour_les_operations_futures": "Currency change for future operations",
  "v9.exceptions.nature.devis_palier_sur_mesure": "Quote for a custom tier",
  "v9.exceptions.nature.essai_d_un_palier_payant": "Trial of a paid tier",
  "v9.exceptions.nature.geste_commercial": "Goodwill gesture",
  "v9.exceptions.nature.prolongation": "Extension",
  "v9.exceptions.nature.prolongation_d_un_essai_en_cours": "Extension of a current trial",
  "v9.exceptions.nature.prolongation_du_delai_de_paiement": "Payment deadline extension",
  "v9.exceptions.nature.regularisation_d_une_exception_partielle": "Settlement of a partial exception",
  "v9.exceptions.nature.remboursement": "Refund",
  "v9.exceptions.periodicite.annuelle": "yearly",
  "v9.exceptions.periodicite.mensuelle": "monthly",
  "v9.exceptions.plateforme.accorder": "Record the exception",
  "v9.exceptions.plateforme.demande_jointe": "In response to the owner's request {{demande}}.",
  "v9.exceptions.plateforme.execution": "Executed by the payment provider when no second signature is required.",
  "v9.exceptions.plateforme.origine": "Settles exception {{exception}}.",
  "v9.exceptions.plateforme.palier_un_seul_chemin": "An organisation's tier only changes from its record (a single path).",
  "v9.exceptions.plateforme.revision_remplace": "A new proposal replaces the current revision: only one can be accepted at a time.",
  "v9.exceptions.plateforme.seconde_non_requise": "No second signature: goodwill gesture or extension.",
  "v9.exceptions.plateforme.seconde_requise": "A second signature by another platform administrator is required.",
  "v9.exceptions.qui_instruit.nominal": "The platform reviews your request and replies here.",
  "v9.exceptions.qui_instruit.seconde_signature": "The platform reviews your request; a refund or a credit note requires a second signature.",
  "v9.exceptions.quoi.demande": "the request",
  "v9.exceptions.quoi.exception": "the exception",
  "v9.exceptions.quota.ai_calls_per_day": "AI calls per day",
  "v9.exceptions.quota.document_size_mb": "Size per document (MB)",
  "v9.exceptions.quota.documents_count": "Documents",
  "v9.exceptions.quota.requests_per_minute": "Requests per minute",
  "v9.exceptions.quota.tokens_per_day": "Tokens per day",
  "v9.exceptions.raison.aucun_moyen": "Add a payment method first: this quote requires a debit.",
  "v9.exceptions.raison.auteur_de_la_demande": "You requested this exception: another platform administrator countersigns it.",
  "v9.exceptions.raison.deja_accordee": "Request granted: it can no longer be withdrawn.",
  "v9.exceptions.raison.deja_executee": "Exception executed: settle it instead of cancelling it.",
  "v9.exceptions.raison.delai_de_reflexion": "Only super administrator: the cooling-off period is still running.",
  "v9.exceptions.raison.demande_close": "Proposal closed.",
  "v9.exceptions.raison.devis_expire": "This quote has expired.",
  "v9.exceptions.raison.facture_a_venir": "The invoice record comes with the invoices batch.",
  "v9.exceptions.raison.moyen_a_venir": "Adding a payment method comes with the subscription batch.",
  "v9.exceptions.raison.partiellement_executee": "Partially executed: settle the remainder.",
  "v9.exceptions.rapprochement.ecart": "Reconciliation gap",
  "v9.exceptions.rapprochement.non_rapproche": "Not reconciled",
  "v9.exceptions.rapprochement.orphelin": "Orphan event",
  "v9.exceptions.rapprochement.rapproche": "Reconciled",
  "v9.exceptions.reessayer": "Retry",
  "v9.exceptions.reference": "Provider reference: {{reference}}",
  "v9.exceptions.reference.absente": "No provider reference.",
  "v9.exceptions.regularisations.vide": "No settlement.",
  "v9.exceptions.regulariser": "Settle",
  "v9.exceptions.reponse.accordee": "Granted by the platform.",
  "v9.exceptions.reponse.en_attente": "Awaiting the platform's response.",
  "v9.exceptions.reponse.refusee": "Refused by the platform: {{motif}}",
  "v9.exceptions.retirer": "Withdraw the request",
  "v9.exceptions.retour": "Back to the subscription",
  "v9.exceptions.retour_organisation": "Back to the organisation's billing",
  "v9.exceptions.sans_montant": "No amount",
  "v9.exceptions.seconde.contresigner": "Countersign",
  "v9.exceptions.seconde.refuser": "Refuse the second signature",
  "v9.exceptions.seconde.seul_super_administrateur": "Only super administrator: self-approval with re-authentication and a cooling-off period, recorded in the log.",
  "v9.exceptions.section.devis": "Quote",
  "v9.exceptions.section.historique": "History",
  "v9.exceptions.section.regularisations": "Settlements",
  "v9.exceptions.section.seconde_signature": "Second signature",
  "v9.exceptions.section.suivi": "Add information or withdraw",
  "v9.exceptions.signataires.auto_approuve": "Self-approved (only super administrator)",
  "v9.exceptions.signataires.contresignee": "Countersigned by {{qui}}",
  "v9.exceptions.signataires.en_attente": "Second signatory pending",
  "v9.exceptions.signataires.non_requis": "No second signature required",
  "v9.exceptions.voir_facture": "View the invoice"
}
